
import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';

export default function InvoiceFooter() {
  return (
    <footer className="bg-stone-100 pt-16 pb-8">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/bff3983fcac7598cf15bb5173700e0d7/b58838733802ef1d20431284565f42b3.jpeg"
                alt="House of FMR"
                className="h-12 w-12 object-contain"
              />
              <div>
                <p className="text-stone-900 font-display text-lg">House of FMR</p>
                <p className="text-amber-600 text-xs tracking-wider uppercase">Events &amp; Styling</p>
              </div>
            </div>
            <p className="text-stone-500 text-sm leading-relaxed">
              Premium event planning and equipment hire across Melbourne. Generate professional invoices for all your hire needs.
            </p>
          </div>

          <div>
            <h4 className="text-amber-700 font-semibold text-xs tracking-wider uppercase mb-4">
              <a href="/">Quick Links</a>
            </h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-stone-500 hover:text-amber-600 transition-colors text-sm cursor-pointer">Home</Link></li>
              <li><Link to="/shop" className="text-stone-500 hover:text-amber-600 transition-colors text-sm cursor-pointer">Shop</Link></li>
              <li><Link to="/services" className="text-stone-500 hover:text-amber-600 transition-colors text-sm cursor-pointer">Services</Link></li>
              <li><Link to="/gallery" className="text-stone-500 hover:text-amber-600 transition-colors text-sm cursor-pointer">Gallery</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-amber-700 font-semibold text-xs tracking-wider uppercase mb-4">
              <a href="#equipment">Equipment Hire</a>
            </h4>
            <ul className="space-y-2">
              <li><span className="text-stone-500 text-sm">Portable Bars</span></li>
              <li><span className="text-stone-500 text-sm">Bar Mats &amp; Accessories</span></li>
              <li><span className="text-stone-500 text-sm">Furniture &amp; Seating</span></li>
              <li><span className="text-stone-500 text-sm">Glassware &amp; Tableware</span></li>
              <li><span className="text-stone-500 text-sm">Lighting &amp; AV</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-amber-700 font-semibold text-xs tracking-wider uppercase mb-4">
              <a href="mailto:hello@houseoffmr.com">Contact</a>
            </h4>
            <ul className="space-y-2 text-sm text-stone-500">
              <li><a href="mailto:hello@houseoffmr.com" className="hover:text-amber-600 transition-colors">hello@houseoffmr.com</a></li>
              <li><a href="tel:0411164144" className="hover:text-amber-600 transition-colors">0411 164 144</a></li>
              <li>Melbourne, VIC, Australia</li>
            </ul>
            <div className="flex gap-3 mt-4">
              {['instagram', 'facebook', 'pinterest'].map((s) => (
                <a key={s} href="#" rel="nofollow" className="w-9 h-9 rounded-full bg-stone-200 flex items-center justify-center text-stone-500 hover:bg-amber-600 hover:text-white transition-all cursor-pointer">
                  <i className={`ri-${s}-line`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-stone-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-stone-400 text-sm">&copy; 2025 House of FMR Events &amp; Hire. All rights reserved.</p>
          <div className="flex items-center gap-6 text-sm">
            <a href="#" className="text-stone-400 hover:text-amber-600 transition-colors cursor-pointer">Privacy</a>
            <a href="#" className="text-stone-400 hover:text-amber-600 transition-colors cursor-pointer">Terms</a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-stone-400 hover:text-amber-600 transition-colors cursor-pointer">Web Design</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
